import { render } from "./ProductsProductEstimatedShipDate.vue?vue&type=template&id=71546f52"
import script from "./ProductsProductEstimatedShipDate.vue?vue&type=script&lang=js"
export * from "./ProductsProductEstimatedShipDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__